<template>
  <base-view>
    <div class="page-fill">

      <!-- Hero -->
      <div class="hero" :style="{ backgroundImage: 'url(' + heroImage + ')' }">
        <div class="hero-overlay" aria-hidden="true"></div>
        <div class="hero-inner">
          <nav class="breadcrumb-row" aria-label="Breadcrumb">
            <router-link to="/" class="breadcrumb-link">Home</router-link>
            <span class="breadcrumb-sep" aria-hidden="true">/</span>
            <span>Employer Login</span>
          </nav>
          <h1 class="hero-title">Employer Login</h1>
          <p class="hero-sub">Select the account type below to get started.</p>
        </div>
      </div>

      <!-- Cards -->
      <div class="cards-wrap">
        <div class="dest-card dest-card-primary">
          <div class="dest-title dest-title-light">Benefits Login</div>
          <p class="dest-desc dest-desc-light">Manage your company's FSA, DCA, HRA, HSA, PKG/TRN, or other benefit accounts.</p>
          <a href="https://admin.rmrbenefits.com/login" target="_blank" rel="noopener noreferrer" class="dest-btn dest-btn-white">
            Employer Login &rarr;<span class="sr-only"> (opens in new tab)</span>
          </a>
        </div>
        <div class="dest-card dest-card-secondary">
          <div class="dest-title">COBRA Login</div>
          <p class="dest-desc">For former employees continuing insurance/health benefits after termination.</p>
          <div class="dest-btn-group">
            <a href="https://cobrapoint.benaissance.com/employerportal/login?state=eyJjYW5jZWxfdXJpIjoiaHR0cHM6Ly9jb2JyYXBvaW50LmJlbmFpc3NhbmNlLmNvbS8iLCJsb2dvdXRfdXJpIjoiaHR0cHM6Ly9jb2JyYXBvaW50LmJlbmFpc3NhbmNlLmNvbS8ifQ%3d%3d" target="_blank" rel="noopener noreferrer" class="dest-btn dest-btn-green">
              COBRA Login<span class="sr-only"> (opens in new tab)</span>
            </a>
            <a href="https://cobrapoint.benaissance.com/Registration/Identify" target="_blank" rel="noopener noreferrer" class="dest-btn dest-btn-muted">
              Register<span class="sr-only"> (opens in new tab)</span>
            </a>
          </div>
        </div>
        <div class="dest-card dest-card-primary">
          <div class="dest-title dest-title-light">FTP Login</div>
          <p class="dest-desc dest-desc-light">Upload your data safely and securely.</p>
          <a href="https://rmr.files.com/login" target="_blank" rel="noopener noreferrer" class="dest-btn dest-btn-white">
            FTP Login &rarr;<span class="sr-only"> (opens in new tab)</span>
          </a>
        </div>
      </div>

    </div>
  </base-view>
</template>

<script>
import BaseView from "@/components/layout/BaseView.vue";

export default {
  name: "EmployerLoginRedesign",
  components: { BaseView },
  data() {
    return { heroImage: require("@/assets/bg.jpg") };
  }
};
</script>

<style scoped>
.page-fill {
  background: #fafafa;
  min-height: calc(100vh - 10rem);
  display: flex;
  flex-direction: column;
}

.hero {
  position: relative;
  width: 100%;
  background-size: cover;
  background-position: center;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.62) 0%, rgba(255,255,255,0.88) 45%, #fafafa 75%, #fafafa 100%);
}
.hero-inner {
  position: relative;
  max-width: 40rem;
  margin: 0 auto;
  padding: 4rem 1.5rem 3.5rem;
  text-align: center;
}

.breadcrumb-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.8125rem;
  color: #6b7280;
  margin-bottom: 0.75rem;
}
.breadcrumb-link { font-weight: 600; color: #096843; text-decoration: none; }
.breadcrumb-link:hover { text-decoration: underline; }
.breadcrumb-sep { opacity: 0.5; }

.hero-title { margin: 0 0 0.5rem; font-size: 2.25rem; font-weight: 800; color: #111827; }
.hero-sub { margin: 0; font-size: 1.0625rem; color: #374151; }

.cards-wrap {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  max-width: 56rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;
}
@media (min-width: 640px) { .cards-wrap { grid-template-columns: repeat(3, 1fr); } }

.dest-card { border-radius: 0.9rem; padding: 1.75rem; display: flex; flex-direction: column; gap: 0.75rem; }
.dest-card-primary { background: #096843; box-shadow: 0 4px 16px -4px rgba(9,104,67,0.35); }
.dest-card-secondary { background: #ffffff; border: 1.5px solid #e5e5e5; }

.dest-title { font-weight: 800; font-size: 1.125rem; color: #111827; }
.dest-title-light { color: #ffffff; }
.dest-desc { margin: 0; font-size: 1rem; line-height: 1.5; color: #6b7280; flex-grow: 1; }
.dest-desc-light { color: rgba(255,255,255,0.85); }

.dest-btn-group { display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: auto; }
.dest-btn {
  display: inline-block;
  width: fit-content;
  padding: 0.625rem 1.25rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.9375rem;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.15s;
  margin-top: auto;
}
.dest-btn:hover { opacity: 0.85; }
.dest-btn-white { background: #ffffff; color: #096843; }
.dest-btn-green { background: #096843; color: #ffffff; }
.dest-btn-muted { background: #f2f2f2; color: #4b4b4b; }
</style>
